import {useState,useEffect} from 'react'



function useCordinates() {
    const [cordinates,setCordinates] = useState(null);
	useEffect(()=>{
		if(navigator.geolocation){
			navigator.geolocation.watchPosition(_position=>{
				setCordinates(_position.coords);
			})
		}
	},[])
    return cordinates;
}

export default useCordinates